export default __webpack_public_path__ + "static/media/spt-7.6b8f1af0.png";